import { withAuth } from 'lib/AutolistAPI';

async function authorizedFetch(url: string, init: RequestInit = {}): Promise<any> {
  const headers = {
    'Content-Type': 'application/json',
  };

  const response = await withAuth(fetch)(url, { ...init, headers });

  if (!response.ok) {
    throw new Error(`Error fetching: ${await response.text()}`);
  }

  return response.json();
}

export default authorizedFetch;
